import type { DefineComponent } from 'vue'

import { createInertiaApp } from '@inertiajs/vue3'
import { createApp, h } from 'vue'
import Vue3Lottie from 'vue3-lottie'
import { ZiggyVue } from 'ziggy-js'
import i18n from '@/plugins/i18n'
import pinia from '@/plugins/pinia'
import problemNotifier from '@/plugins/problem-notifier'
import './bootstrap'
import '@unocss/reset/tailwind.css'
import 'virtual:uno.css'
import '../css/v2.css'

let stale = false
window.addEventListener('popstate', () => {
  stale = true
})

router.on('navigate', (event) => {
  if (stale) {
    router.get(event.detail.page.url, {}, {
      replace: true,
      preserveState: false,
    })
  }
  stale = false
})

function createTitleFormatter(): ((title: string) => string) {
  const page = usePage()

  return (title) => {
    const tenant = page?.props.auth.current_tenant?.name ?? 'Art of Fiber'
    return `${title} - ${tenant}`
  }
}

createInertiaApp({
  title: createTitleFormatter(),
  resolve: async (name) => {
    const pages = await import.meta.glob('./pages/**/*.vue')
    if (!pages[`./pages/${name}.vue`]) {
      throw new Error(`Page not found: ./pages/${name}.vue`)
    }

    const page = (await pages[`./pages/${name}.vue`]()) as DefineComponent
    const root = name.split('/')[0]

    if (!page.default.layout) {
      page.default.layout = (await matchDefault(
        root,
        {
          Guest: () => import('@/layouts/GuestLayout.vue'),
          Storefront: () => import('@/layouts/StorefrontLayout.vue'),
        },
        () => import('@/layouts/AppLayout.vue'),
      )).default
    }

    return page
    // return resolvePageComponent(`./pages/${name}.vue`, import.meta.glob<DefineComponent>('./pages/**/*.vue'));
  },
  setup({ el, App, props, plugin }) {
    el.classList.add('flex', 'flex-col', 'flex-1', 'min-w-0')
    createApp({ render: () => h(App, props) })
      .use(plugin)
      .use(pinia)
      .use(i18n)
      .use(problemNotifier)
      .use(ZiggyVue)
      .use(Vue3Lottie)
      .mount(el)
  },
  progress: false,
})
